import { Box, Flex, Heading, Text, useColorModeValue } from '@chakra-ui/react'
import { RegisterForm } from '@components/RegisterForm'
import { Card } from '@components/ui/Card'
import { Link } from '@components/ui/Link'
import { Logo } from '@components/ui/Logo'
import { Provider } from '@supabase/supabase-js'
import { useUser } from '@utils/useUser'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'

const SignUp = () => {
  const router = useRouter()
  const [, setLoading] = useState(false)
  const { user, signUp } = useUser()
  const [, setMessage] = useState({ type: '', content: '' })

  useEffect(() => {
    if (user) router.replace('/dashboard')
  }, [user])

  const handleOAuthSignIn = async (provider: Provider) => {
    setLoading(true)
    const { error, data } = await signUp({ provider })
    if (error) {
      setMessage({ type: 'error', content: error.message })
    }
    setLoading(false)
  }

  return (
    <Box
      bg={useColorModeValue('gray.50', 'inherit')}
      minH="100vh"
      py="12"
      px={{ base: '4', lg: '8' }}
    >
      <Box maxW="md" mx="auto">
        <Flex justifyContent="center">
          <Logo mx="auto" h="8" mb={{ base: '10', md: '20' }} />
        </Flex>
        <Heading textAlign="center" size="xl" fontWeight="extrabold">
          Register your account
        </Heading>
        <Text mt="4" mb="8" align="center" maxW="md" fontWeight="medium">
          <Text as="span">Already have an account?</Text>
          <Link href="/signin">Log in</Link>
        </Text>
        <Card>
          <RegisterForm />
        </Card>
      </Box>
    </Box>
  )
}
export default SignUp
